module.exports = __webpack_public_path__ + "img/redpill.975995df.png";